import { render, staticRenderFns } from "./ToolbarAdmin.vue?vue&type=template&id=5c258638&scoped=true"
import script from "./ToolbarAdmin.vue?vue&type=script&lang=js"
export * from "./ToolbarAdmin.vue?vue&type=script&lang=js"
import style0 from "./ToolbarAdmin.vue?vue&type=style&index=0&id=5c258638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c258638",
  null
  
)

export default component.exports